export const AGENT_EDITOR_FORM_NAME = 'agentEditor';

export const LEFT_PANEL_WIDTH = 400;

export const ADVANCED_OPTIONS = [
  'maxTokens',
  'temperature',
  'topP',
  'topK',
  'presencePenalty',
  'frequencyPenalty',
  'stopSequences',
  'seed',
  'maxRetries',
  'toolChoice',
  'maxToolRoundtrips',
  'structuredOutputs',
  'enableOpenAIFormat',
  'propertyKeys'
];
